import { useEffect, type ReactNode } from 'react'
import type { FlashStatusType } from '@/Shared/AutoGenerated/Main'
import { AppLogo } from '@/React/Shared/Component/AppLogo'
import { flashMessageStore } from '@/React/Shared/Component/Flash/FlashMessageStore'
import { FlashMessage } from '@/React/Shared/Component/Flash/FlashMessage'

interface AuthLayoutProps {
    appName: string
    flashStatus: FlashStatusType | null
    title: string
    children: ReactNode
}

export function AuthLayout({
    appName,
    flashStatus,
    title,
    children,
}: AuthLayoutProps) {
    // Renders flash messages coming from the server after a page reload/redirect
    useEffect(() => {
        if (flashStatus) {
            flashMessageStore.display(flashStatus)
        }
    }, [flashStatus])

    return (
        <>
            <FlashMessage />

            <main className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
                <section className="sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="flex justify-center">
                        <AppLogo appName={appName} />
                    </div>

                    <h1 className="mt-6 text-center text-xl font-bold leading-9 tracking-tight text-gray-900">
                        {title}
                    </h1>
                </section>

                <section className="mt-6 px-4 sm:mx-auto sm:w-full sm:max-w-[480px] lg:px-0">
                    <div className="rounded-xl border border-stone-200 bg-white px-6 py-12 shadow-xs sm:px-12">
                        {children}
                    </div>
                </section>
            </main>
        </>
    )
}
